import { WholesalePage } from "../features/wholesale/pages/wholesale"
import { DashboardLayout } from "../layouts/DashboardLayout"

export default function WholesaleDashboard() {
  return (
    <DashboardLayout>
      <WholesalePage />
    </DashboardLayout>
  )
}
